module.exports = __webpack_public_path__ + "static/media/qryFuncPlaceholderIcon.7808b67d.svg";